"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8653],{

/***/ 91856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gc": function() { return /* binding */ BAREMETAL_FAQS; },
  "xf": function() { return /* binding */ CERTIFICATIONS; },
  "Ms": function() { return /* binding */ CONTATO; },
  "BA": function() { return /* binding */ LINKS; },
  "cu": function() { return /* binding */ NAVS; },
  "b1": function() { return /* binding */ OUR_DIFFERENCES; },
  "q5": function() { return /* binding */ PAGES; },
  "k1": function() { return /* binding */ SOCIAL; },
  "E1": function() { return /* binding */ getBGPath; }
});

// UNUSED EXPORTS: FeaturedProducts, getBGParceriaURL

;// CONCATENATED MODULE: ./configs/social.js
/* harmony default export */ var social = ([
    {
        "name": "facebook",
        "text": "Facebook",
        "route": "https://financeiro.bbhost.com.br/link.php?id=202",
        "icon": [
            "fab",
            "facebook"
        ],
        "nav": false,
        "color": "facebook",
        "event": "open_facebook"
    },
    {
        "name": "instagram",
        "text": "Instagram",
        "route": "https://financeiro.bbhost.com.br/link.php?id=201",
        "icon": [
            "fab",
            "instagram"
        ],
        "nav": false,
        "color": "rose",
        "event": "open_instagram"
    }
]);

;// CONCATENATED MODULE: ./configs/contato.js
/* harmony default export */ var contato = ([
    {
        "name": "discord",
        "text": "Discord",
        "route": "https://financeiro.bbhost.com.br/link.php?id=206",
        "icon": [
            "fab",
            "discord"
        ],
        "disable": false,
        "nav": true,
        "justIcon": true,
        "color": "transparent",
        "event": "open_discord"
    },
    {
        "name": "whatsapp",
        "text": "Whatsapp",
        "route": "https://financeiro.bbhost.com.br/link.php?id=193",
        "icon": [
            "fab",
            "whatsapp"
        ],
        "disable": false,
        "nav": true,
        "justIcon": true,
        "color": "success",
        "event": "open_whatsapp"
    },
    {
        "name": "telephone",
        "text": "(11) 9 1678-8282",
        "route": "https://financeiro.bbhost.com.br/link.php?id=207",
        "icon": [
            "fas",
            "phone"
        ],
        "disable": false,
        "nav": true,
        "justIcon": false,
        "color": "transparent",
        "event": "open_call_phone"
    }, 
]);

;// CONCATENATED MODULE: ./configs/our_differences.js
/* harmony default export */ var our_differences = ([
    {
        "text": "24/7/365",
        "subText": {
            "br": "Um suporte especializado dispon\xedvel a qualquer momento via ticket, pronto para resolver qualquer d\xfavida ou problema.",
            "en": "Um suporte especializado dispon\xedvel a qualquer momento via ticket, pronto para resolver qualquer d\xfavida ou problema.",
            "es": "Um suporte especializado dispon\xedvel a qualquer momento via ticket, pronto para resolver qualquer d\xfavida ou problema."
        },
        "icon": "chat",
        "iconColor": "info"
    },
    {
        "text": {
            "br": "Prote\xe7\xe3o DDoS Ilimitada",
            "en": "Prote\xe7\xe3o DDoS Ilimitada",
            "es": "Prote\xe7\xe3o DDoS Ilimitada"
        },
        "subText": {
            "br": "Tenha a mitiga\xe7\xe3o de seus ataques independente do tamanho, n\xe3o trabalhamos com null-route ou blackhole!",
            "en": "Tenha a mitiga\xe7\xe3o de seus ataques independente do tamanho, n\xe3o trabalhamos com null-route ou blackhole!",
            "es": "Tenha a mitiga\xe7\xe3o de seus ataques independente do tamanho, n\xe3o trabalhamos com null-route ou blackhole!"
        },
        "icon": "security",
        "iconColor": "danger"
    },
    {
        "text": {
            "br": "Sistemas Inteligentes",
            "en": "Sistemas Inteligentes",
            "es": "Sistemas Inteligentes"
        },
        "subText": {
            "br": "Tenha a libera\xe7\xe3o de seu servidor automaticamente pelos nossos sistemas inteligentes.",
            "en": "Tenha a libera\xe7\xe3o de seu servidor automaticamente pelos nossos sistemas inteligentes.",
            "es": "Tenha a libera\xe7\xe3o de seu servidor automaticamente pelos nossos sistemas inteligentes."
        },
        "icon": "verifieduser",
        "iconColor": "success"
    }
]);

;// CONCATENATED MODULE: ./configs/featured_products.js
/* harmony default export */ var configs_featured_products = ([
    {
        "text": "Intel Xeon E-2286G",
        "configs": [
            {
                "name": "cpu",
                "detail": "6c/12t - 4.0GHz/4.9GHz",
                "icon": [
                    "fas",
                    "microchip"
                ]
            },
            {
                "name": "ram",
                "detail": "32 GB",
                "icon": [
                    "fas",
                    "memory"
                ]
            },
            {
                "name": "disk",
                "detail": "1x1TB NVMe",
                "icon": [
                    "fas",
                    "hdd"
                ]
            }
        ],
        "price": 1200,
        "link": {
            "color": "info",
            "type": "external",
            "href": "https://financeiro.bbhost.com.br/store/dedicados-brasil/intel-xeon-e-2286g"
        },
        "icon": [
            "fas",
            "server"
        ],
        "spotlight": false
    },
    {
        "text": "Intel Xeon E-2388G",
        "configs": [
            {
                "name": "cpu",
                "detail": "8c/16t - 3.2GHz/5.1GHz",
                "icon": [
                    "fas",
                    "microchip"
                ]
            },
            {
                "name": "ram",
                "detail": "64 GB",
                "icon": [
                    "fas",
                    "memory"
                ]
            },
            {
                "name": "disk",
                "detail": "1x1TB NVMe",
                "icon": [
                    "fas",
                    "hdd"
                ]
            }
        ],
        "price": 1500,
        "link": {
            "color": "info",
            "type": "external",
            "href": "https://financeiro.bbhost.com.br/store/dedicados-brasil/intel-xeon-e-2388g"
        },
        "icon": [
            "fas",
            "server"
        ],
        "spotlight": true
    },
    {
        "text": "Intel Dual Xeon E5-2680",
        "configs": [
            {
                "name": "cpu",
                "detail": "16/32t - 2.7GHz/3.5GHz",
                "icon": [
                    "fas",
                    "microchip"
                ]
            },
            {
                "name": "ram",
                "detail": "128 GB",
                "icon": [
                    "fas",
                    "memory"
                ]
            },
            {
                "name": "disk",
                "detail": "1TB SSD",
                "icon": [
                    "fas",
                    "hdd"
                ]
            }
        ],
        "price": 850,
        "link": {
            "color": "info",
            "type": "external",
            "href": "https://financeiro.bbhost.com.br/store/dedicados-brasil/intel-dual-xeon-e5-2680"
        },
        "icon": [
            "fas",
            "server"
        ],
        "spotlight": false
    }
]);

;// CONCATENATED MODULE: ./configs/certifications.js
/* harmony default export */ var certifications = ([
    {
        "name": "manrs",
        "text": "manrs.",
        "subText": {
            "br": "Certifica\xe7\xe3o de Boas Praticas de seguran\xe7a na internet."
        },
        "logo": "/img/certifications/manrs.png",
        "link": "https://financeiro.bbhost.com.br/link.php?id=203",
        "height": "27px",
        "width": "110px"
    }
]);

;// CONCATENATED MODULE: ./configs/navs.js
/* harmony default export */ var navs = ([
    {
        "name": "home",
        "text": {
            "br": "Inicio",
            "en": "Home",
            "es": "Home"
        },
        "type": "link",
        "route": "/"
    },
    {
        "name": "vps",
        "text": "VPS",
        "type": "link",
        "route": "/vps"
    },
    {
        "name": "baremetal",
        "text": "BareMetal",
        "type": "link",
        "route": "/baremetal"
    },
    {
        "name": "colocation",
        "text": "Colocation",
        "type": "link",
        "route": "/colocation"
    },
    {
        "name": "anti_ddos",
        "text": "Anti-DDoS",
        "type": "link",
        "route": "/anti_ddos"
    },
    {
        "name": "infrastructure",
        "text": {
            "br": "Infraestrutura",
            "en": "Infrastructure",
            "es": "Infraestructura"
        },
        "type": "link",
        "route": "/infrastructure"
    }
]);

;// CONCATENATED MODULE: ./configs/links.js
/* harmony default export */ var links = ([
    {
        "name": "legal",
        "text": {
            "br": "Pol\xedticas",
            "en": "Legal"
        },
        "link": "/legal",
        "type": "internal"
    },
    {
        "name": "ajuda",
        "text": {
            "br": "Ajuda",
            "en": "Help"
        },
        "link": "https://financeiro.bbhost.com.br/knowledgebase.php",
        "type": "external"
    },
    {
        "name": "sobrenos",
        "text": {
            "br": "Sobre n\xf3s",
            "en": "About US"
        },
        "link": "/sobrenos",
        "type": "internal"
    }
]);

;// CONCATENATED MODULE: ./configs/pages.js
/* harmony default export */ var pages = ({
    "home": {
        "slider": true,
        "sliders": [
            {
                "title": {
                    "br": "Data Center no Brasil",
                    "en": "Data Center in Brazil",
                    "es": "Centro de datos en Brasil"
                },
                "subTitle": {
                    "br": "Com a melhor infraestrutura e rede de seguran\xe7a, tenha o melhor que h\xe1 em qualidade conosco.",
                    "en": "With the best infrastructure and safety net, have the best quality with us.",
                    "es": "Con la mejor infraestructura y red de seguridad, tenga la mejor calidad con nosotros."
                },
                "action": {
                    "color": "info",
                    "type": "internal",
                    "href": "/infrastructure",
                    "icon": [
                        "fas",
                        "info-circle"
                    ],
                    "text": {
                        "br": "Quero saber mais sobre a estrutura",
                        "en": "I want to know more about the structure",
                        "es": "Quiero saber m\xe1s sobre la estructura"
                    }
                }
            },
            {
                "title": {
                    "br": "Bare Metal",
                    "en": "Bare Metal",
                    "es": "Bare Metal"
                },
                "subTitle": {
                    "br": "Tenha seu pr\xf3prio dedicado utilizando todos os recursos, sem compartilhamento!",
                    "en": "Have your own dedicated using with every resource without sharing!",
                    "es": "\xa1Tenga su propio uso dedicado con cada recurso sin compartir!"
                },
                "action": {
                    "color": "info",
                    "type": "internal",
                    "href": "/baremetal",
                    "icon": [
                        "fas",
                        "info-circle"
                    ],
                    "text": {
                        "br": "Ver baremetal",
                        "en": "Ver baremetal",
                        "es": "Ver baremetal"
                    }
                }
            },
            {
                "title": "Colocation",
                "subTitle": {
                    "br": "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a opera\xe7\xe3o.",
                    "en": "Infrastructure with state-of-the-art equipment to ensure the reliability of the entire operation.",
                    "es": "Infraestructura con equipos de \xfaltima generaci\xf3n para garantizar la confiabilidad de toda la operaci\xf3n."
                },
                "action": {
                    "color": "info",
                    "type": "internal",
                    "href": "/colocation",
                    "icon": [
                        "fas",
                        "info-circle"
                    ],
                    "text": {
                        "br": "Saber mais",
                        "en": "Saber mais",
                        "es": "Saber mais"
                    }
                }
            }
        ],
        "title": {
            "br": "Data Center no Brasil",
            "en": "Data Center in Brazil",
            "es": "Centro de datos en Brasil"
        },
        "subTitle": {
            "br": "Com a melhor infraestrutura e rede de seguran\xe7a, tenha o melhor que h\xe1 em qualidade conosco.",
            "en": "With the best infrastructure and safety net, have the best quality with us.",
            "es": "Con la mejor infraestructura y red de seguridad, tenga la mejor calidad con nosotros."
        },
        "action": {
            "color": "info",
            "type": "internal",
            "href": "/infrastructure",
            "icon": [
                "fas",
                "info-circle"
            ],
            "text": {
                "br": "Quero saber mais sobre a estrutura",
                "en": "I want to know more about the structure",
                "es": "Quiero saber m\xe1s sobre la estructura"
            }
        }
    },
    "vps": {
        "title": "VPS",
        "subTitle": {
            "br": "Servidores de alta disponibilidade em hardware dedicado e alta capacidade de escalonamento.",
            "en": "High availability servers on dedicated hardware and high scalability.",
            "es": "Servidores de alta disponibilidad en hardware dedicado y alta escalabilidad."
        },
        "action": false
    },
    "baremetal": {
        "title": "Bare Metal",
        "subTitle": {
            "br": "Tenha seu pr\xf3prio dedicado utilizando todos os recursos, sem compartilhamento!",
            "en": "Have your own dedicated using with every resource without sharing!",
            "es": "\xa1Tenga su propio uso dedicado con cada recurso sin compartir!"
        },
        "action": false
    },
    "colocation": {
        "title": "Colocation",
        "subTitle": "",
        "action": false
    },
    "anti_ddos": {
        "title": "Anti-DDoS",
        "subTitle": {
            "br": "Sem altera\xe7\xf5es de rota, sem aumento de ping ou atraso para mitigar seu ataque.",
            "en": "Sem altera\xe7\xf5es de rota, sem aumento de ping ou atraso para mitigar seu ataque.",
            "es": "Sem altera\xe7\xf5es de rota, sem aumento de ping ou atraso para mitigar seu ataque."
        },
        "action": false
    },
    "infrastructure": {
        "title": {
            "br": "Infraestrutura",
            "en": "Infrastructure",
            "es": "Infraestructura"
        },
        "subTitle": {
            "br": "Infraestrutura com equipamentos de ponta, para garantir a confiabilidade de toda a opera\xe7\xe3o.",
            "en": "Infrastructure with state-of-the-art equipment to ensure the reliability of the entire operation.",
            "es": "Infraestructura con equipos de \xfaltima generaci\xf3n para garantizar la confiabilidad de toda la operaci\xf3n."
        },
        "action": false
    },
    "legal": {
        "title": {
            "br": "Pol\xedticas Legais",
            "en": "Legal Policies",
            "es": "Pol\xedticas legales"
        },
        "subTitle": {
            "br": "Aqui voc\xea encontr\xe1 mais sobre as politicas da BB Host.",
            "en": "Here you will find more about BB Host policies.",
            "es": "Aqu\xed encontrar\xe1 m\xe1s informaci\xf3n sobre las pol\xedticas de BB Host."
        },
        "action": false
    },
    "about_us": {
        "title": {
            "br": "Sobre N\xf3s",
            "en": "About Us",
            "es": "Sobre nosotros"
        },
        "subTitle": {
            "br": "Aqui voc\xea encontra mais sobre a hist\xf3ria da BB Host.",
            "en": "Here you can find more about the history of BB Host.",
            "es": "Aqu\xed puede encontrar m\xe1s informaci\xf3n sobre la historia de BB Host."
        }
    },
    "blog": {
        "title": "Blog",
        "subTitle": "",
        "action": false
    },
    "404": {
        "title": {
            "br": "Pagina n\xe3o encontrada",
            "en": "Page not found",
            "es": "P\xe1gina no encontrada"
        },
        "subTitle": ""
    },
    "500": {
        "title": "ERROR 500",
        "subTitle": {
            "br": "Ocorreu um erro do lado do servidor.",
            "en": "A server-side error has occurred..",
            "es": "Ha ocurrido un error del lado del servidor.."
        }
    },
    "status": {
        "slider": false
    }
});

// EXTERNAL MODULE: ./public/img/bg/capa_fundo_dedicado.png
var capa_fundo_dedicado = __webpack_require__(4789);
;// CONCATENATED MODULE: ./public/img/bg/hallowen.png
/* harmony default export */ var hallowen = ({"src":"/_next/static/media/hallowen.af96e37d.png","height":551,"width":1921,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAJFBMVEUTQHslVIJEibEjZ6EOVo9tnrgPPmdQdZUXXY9OcpRCYIKEn7OMdYNYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGPgYGbiZmViZmFgY+Ri52RkYAAAAuEASTYTQtcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/bg/bbhost_natal_2.png
/* harmony default export */ var bbhost_natal_2 = ({"src":"/_next/static/media/bbhost_natal_2.ee1bfbc8.png","height":413,"width":1440,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAIVBMVEU1XZ5GcbgoVJwTMmYpTYAHIFMZRodAZ5UsV401Watihc9Z5QzIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZmFnYmRgYGFgZeZg5OJkYgMAAf4AQo6htZUAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/img/bg/mobile/capa_fundo_dedicado_mobile.png
/* harmony default export */ var capa_fundo_dedicado_mobile = ({"src":"/_next/static/media/capa_fundo_dedicado_mobile.97dfae44.png","height":1920,"width":1080,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAANlBMVEUAF1hLaZ8CSKeBk7wGI2cYP4wgQH0CJ3AJNYEAG2JOba1khMIzV5WoscoCPJOVob5ceKcXMXAIZWsrAAAACXBIWXMAAC4jAAAuIwF4pT92AAAAMUlEQVR4nBXESRKAIBAEwQJn6REU/P9nCfOQ9P4qkVKO2p5BrOcKvjZuw9I9gbJ/qg4bfQEJjcbkJAAAAABJRU5ErkJggg==","blurWidth":5,"blurHeight":8});
;// CONCATENATED MODULE: ./public/img/bg/mobile/hallowen.png
/* harmony default export */ var mobile_hallowen = ({"src":"/_next/static/media/hallowen.c71f3d75.png","height":551,"width":600,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAVFBMVEVNkLKhtMJ7pbsNH1tembVaiqqKqr1pm7Yxe6lgoLttoLgUJ1QyeKkNMmKRrb5EcZYVHkyvlY9Jg6xnkasvNWpORWcxdqI9irJ8i58wU32AiZs8fqs3yuN2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nAXBhQHAMAwDMKcNlHH8/6GTUJasEEKBKZElBrjNSc0Bpt+jLgLgGC1twSu939d5YORRq/f5Bz+HAjqYdsSjAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});
;// CONCATENATED MODULE: ./public/img/bg/mobile/bbhost_natal_mobile.png
/* harmony default export */ var bbhost_natal_mobile = ({"src":"/_next/static/media/bbhost_natal_mobile.b50ea463.png","height":1440,"width":810,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAKlBMVEULNHwAHFoDImUaQooGLHIuTZw6ZJtjdcEgTY0lRZoLOoc2WJBaeKc4VKdKTFZRAAAACXBIWXMAAC4jAAAuIwF4pT92AAAALElEQVR4nAXBiQGAMAwDsbOdpA+w/7pIeB691GQPpLPJWt8h3Qe4lDGUkGX9E1oAqrpwONQAAAAASUVORK5CYII=","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./configs/bg.js







function getBGPath_(name) {
    var mobileForce = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (lib/* isMobile */.tq || mobileForce) return getBGMobilePath(name);
    return getBGDesktopPath(name);
}
function getBGDesktopPath(name) {
    if (BGPath[name] !== undefined) return BGPath[name];
    return BGPath["default"];
}
function getBGMobilePath(name) {
    if (BGMobileConfig[name] !== undefined) return BGMobileConfig[name];
    return BGMobileConfig["default"];
}
var BGPath = {
    "default": capa_fundo_dedicado/* default */.Z,
    "hallowen": hallowen,
    "natal": bbhost_natal_2,
    "pre_natal": bbhost_natal_2,
    "ano_novo": bbhost_natal_2
};
var BGMobileConfig = {
    "default": capa_fundo_dedicado_mobile,
    "hallowen": mobile_hallowen,
    "natal": bbhost_natal_mobile,
    "pre_natal": bbhost_natal_mobile,
    "ano_novo": bbhost_natal_mobile
};

;// CONCATENATED MODULE: ./configs/parceria.js
var BGParceriaConfig = {
    "default": "https://cdn.bbhost.com.br/images/bg/capa_fundo_dedicado.png",
    "staid": "https://cdn.bbhost.com.br/images/bg/capa_fundo_vps.png"
};
function parceria_getBGParceriaPath(name) {
    if (BGParceriaConfig[name] !== undefined) return BGParceriaConfig[name];
    return BGParceriaConfig["default"];
}

;// CONCATENATED MODULE: ./configs/products/baremetal.js
var baremetal_faqs = {
    "highlights": [
        {
            "name": "datacenter",
            "icon": "Business",
            "icon_color": "info",
            "text": {
                "br": "Datacenter no Brasil",
                "en": "Datacenter no Brasil",
                "es": "Datacenter no Brasil"
            },
            "subText": {
                "br": "Estrutura localizada em Cotia- SP, contando com diversas modernidades e certifica\xe7\xf5es, a fim de entregar uma \xf3tima experi\xeancia a nossos clientes.",
                "en": "Structure located in Cotia-SP, with several modern features and certifications in order to deliver a great experience to our customers.",
                "es": "Estrutura localizada em Cotia- SP, contando com diversas modernidades e certifica\xe7\xf5es a fim de entregar uma \xf3tima experi\xeancia a nossos clientes."
            },
            "more_link": {
                "name": "datacenter_link",
                "text": {
                    "br": "Saber mais.",
                    "en": "Saber mais.",
                    "es": "Saber mais."
                },
                "color": "primary",
                "icon": [
                    "fas",
                    "info-circle"
                ],
                "link": "/infrastructure",
                "type": "internal"
            }
        },
        {
            "name": "anti_ddos",
            "icon": "Security",
            "icon_color": "success",
            "text": {
                "br": "Mitiga\xe7\xe3o eficiente",
                "en": "Mitiga\xe7\xe3o eficiente",
                "es": "Mitiga\xe7\xe3o eficiente"
            },
            "subText": {
                "br": "Sem altera\xe7\xf5es de rota, sem aumento de ping ou atraso para mitigar seu ataque, com 348 Tbps de capacidade.",
                "en": "No route changes, no ping boost or delay to mitigate your attack, with 348 Tbps of capacity.",
                "es": "Sem altera\xe7\xf5es de rota, sem aumento de ping ou atraso para mitigar seu ataque, com 348 Tbps de capacidade."
            },
            "more_link": {
                "name": "anti_ddos_link",
                "text": {
                    "br": "Saber mais.",
                    "en": "Saber mais.",
                    "es": "Saber mais."
                },
                "color": "primary",
                "icon": [
                    "fas",
                    "info-circle"
                ],
                "link": "/infrastructure?index=anti_ddos",
                "type": "internal"
            }
        },
        {
            "name": "conectividade",
            "icon": "Public",
            "icon_color": "info",
            "text": {
                "br": "Conectividade",
                "en": "Conectividade",
                "es": "Conectividade"
            },
            "subText": {
                "br": "Tenha o melhor ping e estabilidade do Brasil, garantindo toda a seguran\xe7a e estabilidade, al\xe9m de uma rede protegida.",
                "en": "Have the best ping and stability in Brazil, ensuring all security and stability, in addition to a protected network.",
                "es": "Tenha o melhor ping e estabilidade do Brasil, garantindo toda a seguran\xe7a e estabilidade, al\xe9m de uma rede protegida."
            },
            "more_link": {
                "name": "network_link",
                "text": {
                    "br": "Saber mais.",
                    "en": "Saber mais.",
                    "es": "Saber mais."
                },
                "color": "primary",
                "icon": [
                    "fas",
                    "info-circle"
                ],
                "link": "/infrastructure?index=network",
                "type": "internal"
            }
        }
    ],
    "list": [
        {
            "title": "Qual o prazo de ativa\xe7\xe3o ?",
            "text": "O tempo de ativa\xe7\xe3o pode variar com o tipo de m\xe1quina contratada."
        },
        {
            "title": "Como funciona a mitiga\xe7\xe3o ?",
            "text": "A mitiga\xe7\xe3o trabalha a todo momento identificando qualquer anomalia em seu tr\xe1fego e mitigando se necess\xe1rio, possuindo mais de 348 Tbps no plano incluso. O DDoS Pro funciona em uma camada extra, analisando tudo que chega a seu servidor e permitindo apenas as conex\xf5es compat\xedveis com o jogo ou aplica\xe7\xe3o."
        },
        {
            "title": "Como \xe9 cobrado o tr\xe1fego ?",
            "text": "Cobramos apenas o uso em upload, sendo contabilizado seu uso. \xc9 poss\xedvel acompanhar pelo painel qual seu uso atual e realizar o aumento de plano."
        },
        {
            "title": "\xc9 permitido jogos nos servidores BB Host ?",
            "text": "Sim, autorizamos e possu\xedmos uma das principais mitiga\xe7\xf5es no mercado brasileiro especializada em jogos."
        },
        {
            "title": "O que s\xe3o servidores spot ?",
            "text": "S\xe3o servidores \xfanicos, chances \xfanicas de adquirir servidores de alta qualidade a um baixo pre\xe7o. Estoques limitados."
        }
    ]
};

;// CONCATENATED MODULE: ./configs/index.js










var SOCIAL = social;
var CONTATO = contato;
var CERTIFICATIONS = certifications;
var OUR_DIFFERENCES = our_differences;
var FeaturedProducts = (/* unused pure expression or super */ null && (featured_products));
var NAVS = navs;
var LINKS = links;
var PAGES = pages;
var getBGPath = getBGPath_;
var getBGParceriaURL = (/* unused pure expression or super */ null && (getBGParceriaPath));

var BAREMETAL_FAQS = baremetal_faqs;


/***/ }),

/***/ 75994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AppBar/AppBar.js
var AppBar = __webpack_require__(45258);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(28358);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Hidden/Hidden.js + 4 modules
var Hidden = __webpack_require__(96642);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Drawer/Drawer.js + 3 modules
var Drawer = __webpack_require__(78008);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Menu.js
var Menu = __webpack_require__(48884);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/headerStyle.js



var headerStyle = {
    appBar: {
        display: "flex",
        border: "0",
        borderRadius: "3px",
        padding: "0.625rem 0",
        marginBottom: "20px",
        color: "#555",
        width: "100%",
        backgroundColor: "#fff",
        boxShadow: "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
        transition: "all 150ms ease 0s",
        alignItems: "center",
        flexFlow: "row nowrap",
        justifyContent: "flex-start",
        position: "relative",
        zIndex: "unset"
    },
    absolute: {
        position: "absolute",
        zIndex: "1100"
    },
    fixed: {
        position: "fixed",
        zIndex: "1100"
    },
    container: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* container */.nC), {
        minHeight: "50px",
        flex: "1",
        alignItems: "center",
        justifyContent: "space-between",
        display: "flex",
        flexWrap: "nowrap",
        "@media (min-width: 1200px)": {
            maxWidth: "1500px"
        }
    }),
    flex: {
        flex: 1
    },
    title: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* defaultFont */.Df), {
        lineHeight: "30px",
        fontSize: "18px",
        borderRadius: "3px",
        textTransform: "none",
        color: "inherit",
        padding: "8px 16px",
        letterSpacing: "unset",
        "&:hover,&:focus": {
            color: "inherit",
            background: "transparent"
        }
    }),
    appResponsive: {
        margin: "20px 10px"
    },
    primary: {
        backgroundColor: bbhost/* primaryColor */.lr,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* primaryColor */.lr, 0.46))
    },
    info: {
        backgroundColor: bbhost/* infoColor */.bE,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* infoColor */.bE, 0.46))
    },
    success: {
        backgroundColor: bbhost/* successColor */.nq,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* successColor */.nq, 0.46))
    },
    warning: {
        backgroundColor: bbhost/* warningColor */.MA,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* warningColor */.MA, 0.46))
    },
    danger: {
        backgroundColor: bbhost/* dangerColor */.E7,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* dangerColor */.E7, 0.46))
    },
    rose: {
        backgroundColor: bbhost/* roseColor */.An,
        color: "#FFFFFF",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px ".concat((0,bbhost/* hexToRGBAlpha */.vS)(bbhost/* roseColor */.An, 0.46))
    },
    transparent: {
        backgroundColor: "transparent !important",
        boxShadow: "none",
        paddingTop: "25px",
        color: "#FFFFFF"
    },
    dark: {
        color: "#FFFFFF",
        backgroundColor: "#212121 !important",
        boxShadow: "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
    },
    white: {
        border: "0",
        padding: "0.625rem 0",
        marginBottom: "20px",
        color: "#555",
        backgroundColor: "#fff !important",
        boxShadow: "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)"
    },
    drawerPaper: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        border: "none",
        bottom: "0",
        transitionProperty: "top, bottom, width",
        transitionDuration: ".2s, .2s, .35s",
        transitionTimingFunction: "linear, linear, ease",
        width: bbhost/* drawerWidth */.RK
    }, bbhost/* boxShadow */.Wn), {
        position: "fixed",
        display: "block",
        top: "0",
        height: "100vh",
        right: "0",
        left: "auto",
        visibility: "visible",
        overflowY: "visible",
        borderTop: "none",
        textAlign: "left",
        paddingRight: "0px",
        paddingLeft: "0"
    }), bbhost/* transition */.eR)
};
/* harmony default export */ var components_headerStyle = (headerStyle);

;// CONCATENATED MODULE: ./public/img/bbhost_white.png
/* harmony default export */ var bbhost_white = ({"src":"/_next/static/media/bbhost_white.9934180a.png","height":865,"width":1638,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEX6+fn6+fn/+/v6+fn7+vr6+fn7+/v5+fn6+vr8+fn///8wAQqQAAAAC3RSTlOLeBmoTr6bXjxVQ+UVbiUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAlSURBVHicBcGJAQAgDAKxA/qo+w9sgk+3bSOShmFIxCukWnHrAwb2AGWUtgy1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./components/Header/Header.js







// nodejs library that concatenates classes

// nodejs library to set properties for components











var styles = (0,_object_spread/* default */.Z)({}, components_headerStyle);
var useStyles = (0,makeStyles/* default */.Z)(styles);
function Header(props) {
    var classes = useStyles();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), mobileOpen = ref[0], setMobileOpen = ref[1];
    react.useEffect(function() {
        if (props.changeColorOnScroll) {
            window.addEventListener("scroll", headerColorChange);
        }
        return function cleanup() {
            if (props.changeColorOnScroll) {
                window.removeEventListener("scroll", headerColorChange);
            }
        };
    });
    var handleDrawerToggle = function() {
        setMobileOpen(!mobileOpen);
    };
    var headerColorChange = function() {
        var color = props.color, changeColorOnScroll = props.changeColorOnScroll;
        var windowsScrollTop = window.pageYOffset;
        if (windowsScrollTop > changeColorOnScroll.height) {
            document.body.getElementsByTagName("header")[0].classList.remove(classes[color]);
            document.body.getElementsByTagName("header")[0].classList.add(classes[changeColorOnScroll.color]);
        } else {
            document.body.getElementsByTagName("header")[0].classList.add(classes[color]);
            document.body.getElementsByTagName("header")[0].classList.remove(classes[changeColorOnScroll.color]);
        }
    };
    var color = props.color, rightLinks = props.rightLinks, leftLinks = props.leftLinks, brand = props.brand, fixed = props.fixed, absolute = props.absolute, brand_icon = props.brand_icon, index = props.index;
    var _obj;
    var appBarClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.appBar, true), (0,_define_property/* default */.Z)(_obj, classes[color], color), (0,_define_property/* default */.Z)(_obj, classes.absolute, absolute), (0,_define_property/* default */.Z)(_obj, classes.fixed, fixed), _obj));
    var brandComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (brand_icon !== undefined) {
        if (!index) brandComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            as: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                style: {
                    padding: "10px 30px",
                    maxWidth: "185px",
                    width: "185px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    layout: "fixed",
                    src: bbhost_white,
                    width: 185,
                    height: 70,
                    alt: "BB Host",
                    quality: 100
                })
            })
        });
        else brandComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            style: {
                padding: "10px 30px",
                maxWidth: "185px",
                width: "185px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                layout: "fixed",
                src: bbhost_white,
                width: 185,
                height: 70,
                alt: "BB Host",
                quality: 100
            })
        });
    } else {
        brandComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            as: "/",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: classes.title,
                children: brand
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppBar/* default */.Z, {
        className: appBarClasses,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                className: classes.container,
                children: [
                    leftLinks !== undefined ? brandComponent : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.flex,
                        children: leftLinks !== undefined ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                            mdDown: true,
                            implementation: "css",
                            children: leftLinks
                        }) : brandComponent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                        mdDown: true,
                        implementation: "css",
                        children: rightLinks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                        lgUp: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                            color: "inherit",
                            "aria-label": "open drawer",
                            onClick: handleDrawerToggle,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* default */.Z, {
                lgUp: true,
                implementation: "js",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                    variant: "temporary",
                    anchor: "right",
                    open: mobileOpen,
                    classes: {
                        paper: classes.drawerPaper
                    },
                    onClose: handleDrawerToggle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.appResponsive,
                        children: [
                            leftLinks,
                            rightLinks
                        ]
                    })
                })
            })
        ]
    });
}
Header.defaultProp = {
    color: "white",
    index: false
};
Header.propTypes = {
    color: prop_types_default().oneOf([
        "primary",
        "info",
        "success",
        "warning",
        "danger",
        "transparent",
        "white",
        "rose",
        "dark", 
    ]),
    rightLinks: (prop_types_default()).node,
    leftLinks: (prop_types_default()).node,
    brand: (prop_types_default()).string,
    fixed: (prop_types_default()).bool,
    index: (prop_types_default()).bool,
    absolute: (prop_types_default()).bool,
    changeColorOnScroll: prop_types_default().shape({
        height: (prop_types_default()).number.isRequired,
        color: prop_types_default().oneOf([
            "primary",
            "info",
            "success",
            "warning",
            "danger",
            "transparent",
            "white",
            "rose",
            "dark", 
        ]).isRequired
    })
};

// EXTERNAL MODULE: ./styles/jss/bbhost/pages/componentsSections/navbarsStyle.js + 1 modules
var navbarsStyle = __webpack_require__(28886);
// EXTERNAL MODULE: ./configs/index.js + 16 modules
var configs = __webpack_require__(91856);
// EXTERNAL MODULE: ./constants.js
var constants = __webpack_require__(68148);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./pages-sections/HeaderSection.js








// const Header = dynamic(() => import('/components/Header/Header.js'), { ssr: true });
var HeaderNavItem = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(3490), __webpack_require__.e(1707), __webpack_require__.e(4902)]).then(__webpack_require__.bind(__webpack_require__, 24902));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24902)
            ];
        }
    }
});
var SocialNav = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(3762)]).then(__webpack_require__.bind(__webpack_require__, 3762));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3762)
            ];
        }
    }
});
var ActionNav = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(7335)]).then(__webpack_require__.bind(__webpack_require__, 87335));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(87335)
            ];
        }
    }
});
var LocationNav = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1800), __webpack_require__.e(4817), __webpack_require__.e(3490), __webpack_require__.e(1707), __webpack_require__.e(9093)]).then(__webpack_require__.bind(__webpack_require__, 19093));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19093)
            ];
        }
    }
});
var Parallax = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5363).then(__webpack_require__.bind(__webpack_require__, 15363));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15363)
            ];
        }
    }
});
var List = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3240).then(__webpack_require__.bind(__webpack_require__, 53240));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53240)
            ];
        }
    }
});

// Sections for this page
// import HeaderSectionParallax from "pages-sections/HeaderSectionParallax.js";
var HeaderSectionParallax = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3025).then(__webpack_require__.bind(__webpack_require__, 73025));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(73025)
            ];
        }
    },
    ssr: false
});
var HeaderSectionSliderParallax = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 399).then(__webpack_require__.bind(__webpack_require__, 80399));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80399)
            ];
        }
    },
    ssr: false
});
var HeaderSection_styles = (0,_object_spread/* default */.Z)({}, navbarsStyle/* default */.Z);
var HeaderSection_useStyles = (0,makeStyles/* default */.Z)(HeaderSection_styles);



function HeaderSection(props) {
    var classes = HeaderSection_useStyles();
    var name = props.name, blocked = props.blocked;
    var seo = props.seo || {
        title: "BB Host",
        description: "BB Host, datacenter de qualidade!",
        url: "https://www.bbhost.com.br",
        type: "website",
        languageAlternates: [
            {
                hrefLang: "en",
                href: "https://www.bbhost.com.br/en"
            },
            {
                hrefLang: "es",
                href: "https://www.bbhost.com.br/es"
            }
        ]
    };
    var socialItemList = configs/* CONTATO.map */.Ms.map(function(item, key) {
        if (item.nav !== undefined && item.nav && item.disable !== undefined && !item.disable) return /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialNav, {
            item: item
        }, key);
    });
    var navItemList = configs/* NAVS.map */.cu.map(function(nav, key) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderNavItem, {
            nav: nav,
            active_name: name
        }, key);
    });
    var rightNavs = /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
        className: classes.list,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionNav, {
                color: "transparent",
                name: "painel_client",
                text: "navs::client",
                route: "https://financeiro.bbhost.com.br/",
                icon: [
                    "far",
                    "user"
                ]
            }),
            socialItemList,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationNav, {})
        ]
    });
    var leftLinks = /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
        className: classes.list,
        children: navItemList
    });
    var parallaxSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    if (configs/* PAGES */.q5[name] != undefined) parallaxSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionParallax, (0,_object_spread/* default */.Z)({}, configs/* PAGES */.q5[name]));
    if (configs/* PAGES */.q5[name] != undefined && configs/* PAGES */.q5[name].sliders != undefined && !lib/* isMobile */.tq) parallaxSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSectionSliderParallax, (0,_object_spread/* default */.Z)({}, configs/* PAGES */.q5[name]));
    var openGraphImage = (0,configs/* getBGPath */.E1)(name);
    if (seo.images == undefined) {
        seo.images = [
            {
                url: "".concat((0,constants/* getDomainByENV */.ln)()).concat(openGraphImage.src),
                width: 800,
                height: 600,
                alt: seo.description
            }, 
        ];
    }
    if (blocked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: seo.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: seo.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, {
                    languageAlternates: seo.languageAlternates
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                    openGraph: {
                        type: seo.type,
                        url: seo.url,
                        title: seo.title,
                        description: seo.description,
                        images: seo.images
                    },
                    canonical: seo.url
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    color: "transparent",
                    brand_icon: true,
                    fixed: true,
                    changeColorOnScroll: {
                        height: 80,
                        color: "dark"
                    },
                    index: name === "home"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Parallax, {
                    small: true,
                    filter: true,
                    responsive: true,
                    name: name,
                    blocked: true,
                    children: parallaxSection
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: seo.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: seo.description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, {
                languageAlternates: seo.languageAlternates
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                openGraph: {
                    type: seo.type,
                    url: seo.url,
                    title: seo.title,
                    description: seo.description,
                    images: seo.images
                },
                canonical: seo.url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                color: "transparent",
                brand_icon: true,
                rightLinks: rightNavs,
                leftLinks: leftLinks,
                fixed: true,
                changeColorOnScroll: {
                    height: 80,
                    color: "dark"
                },
                index: name === "home"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Parallax, {
                small: true,
                filter: true,
                responsive: true,
                name: name,
                children: parallaxSection
            })
        ]
    });
}


/***/ }),

/***/ 89395:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var imagesStyles = {
    imgFluid: {
        maxWidth: "100%",
        height: "auto"
    },
    imgRounded: {
        borderRadius: "6px !important"
    },
    imgRoundedCircle: {
        borderRadius: "50% !important"
    },
    imgRaised: {
        boxShadow: "0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },
    imgGallery: {
        width: "100%",
        marginBottom: "2.142rem"
    },
    imgCardLeft: {
        width: "40%",
        borderTopLeftRadius: "calc(.25rem - 1px)",
        borderTopRightRadius: "calc(.25rem - 1px)"
    },
    imgCardTop: {
        width: "100%",
        borderTopLeftRadius: "calc(.25rem - 1px)",
        borderTopRightRadius: "calc(.25rem - 1px)"
    },
    imgCardBottom: {
        width: "100%",
        borderBottomLeftRadius: "calc(.25rem - 1px)",
        borderBottomRightRadius: "calc(.25rem - 1px)"
    },
    imgCard: {
        width: "100%",
        borderRadius: "calc(.25rem - 1px)"
    },
    imgCardOverlay: {
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
        padding: "1.25rem"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (imagesStyles);


/***/ }),

/***/ 28886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ componentsSections_navbarsStyle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./styles/jss/bbhost.js
var bbhost = __webpack_require__(21086);
// EXTERNAL MODULE: ./styles/jss/bbhost/tooltipsStyle.js
var tooltipsStyle = __webpack_require__(39832);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/headerLinksStyle.js





var headerLinksStyle = function(theme) {
    var _obj, _obj1;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        list: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* defaultFont */.Df), {
            fontSize: "14px",
            margin: 0,
            paddingLeft: "0",
            listStyle: "none",
            paddingTop: "0",
            paddingBottom: "0",
            color: "inherit"
        }),
        listItem: (0,_define_property/* default */.Z)({
            float: "left",
            color: "inherit",
            position: "relative",
            display: "block",
            width: "auto",
            margin: "0",
            padding: "0"
        }, theme.breakpoints.down("md"), {
            width: "100%",
            "&:after": {
                width: "calc(100% - 30px)",
                content: '""',
                display: "block",
                height: "1px",
                marginLeft: "15px",
                backgroundColor: "#e5e5e5"
            }
        }),
        listItemText: {
            padding: "0 !important"
        },
        navLink: (0,_define_property/* default */.Z)({
            color: "inherit",
            position: "relative",
            padding: "0.9375rem",
            fontWeight: "400",
            fontSize: "12px",
            textTransform: "uppercase",
            borderRadius: "3px",
            lineHeight: "20px",
            textDecoration: "none",
            margin: "0px",
            display: "inline-flex",
            "&:hover,&:focus": {
                color: "inherit",
                background: "rgba(200, 200, 200, 0.2)"
            }
        }, theme.breakpoints.down("md"), {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }),
        notificationNavLink: (_obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            top: "0",
            margin: "5px 15px"
        }), (0,_define_property/* default */.Z)(_obj, "color", "#FFF"), (0,_define_property/* default */.Z)(_obj, "padding", "0.9375rem"), (0,_define_property/* default */.Z)(_obj, "fontWeight", "400"), (0,_define_property/* default */.Z)(_obj, "fontSize", "12px"), (0,_define_property/* default */.Z)(_obj, "textTransform", "uppercase"), (0,_define_property/* default */.Z)(_obj, "lineHeight", "20px"), (0,_define_property/* default */.Z)(_obj, "textDecoration", "none"), (0,_define_property/* default */.Z)(_obj, "margin", "0px"), (0,_define_property/* default */.Z)(_obj, "display", "inline-flex"), (0,_define_property/* default */.Z)(_obj, "top", "4px"), _obj),
        registerNavLink: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.down("md"), {
            top: "0",
            margin: "5px 15px"
        }), (0,_define_property/* default */.Z)(_obj1, "top", "3px"), (0,_define_property/* default */.Z)(_obj1, "position", "relative"), (0,_define_property/* default */.Z)(_obj1, "fontWeight", "400"), (0,_define_property/* default */.Z)(_obj1, "fontSize", "12px"), (0,_define_property/* default */.Z)(_obj1, "textTransform", "uppercase"), (0,_define_property/* default */.Z)(_obj1, "lineHeight", "20px"), (0,_define_property/* default */.Z)(_obj1, "textDecoration", "none"), (0,_define_property/* default */.Z)(_obj1, "margin", "0px"), (0,_define_property/* default */.Z)(_obj1, "display", "inline-flex"), _obj1),
        navLinkActive: {
            color: "inherit",
            backgroundColor: "rgba(255, 255, 255, 0.1)"
        },
        icons: {
            width: "20px",
            height: "20px",
            marginRight: "3px"
        },
        socialIcons: {
            position: "relative",
            fontSize: "20px !important",
            marginRight: "4px"
        },
        dropdownLink: {
            "&,&:hover,&:focus": {
                color: "inherit",
                textDecoration: "none",
                display: "block",
                padding: "10px 20px"
            }
        }
    }, tooltipsStyle/* default */.Z), {
        marginRight5: {
            marginRight: "5px"
        }
    });
};
/* harmony default export */ var components_headerLinksStyle = (headerLinksStyle);

;// CONCATENATED MODULE: ./styles/jss/bbhost/pages/componentsSections/navbarsStyle.js





var navbarsStyle = function(theme) {
    var _obj, _obj1;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        section: {
            padding: "70px 0",
            paddingTop: "0"
        },
        container: bbhost/* container */.nC,
        title: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bbhost/* title */.TN), {
            marginTop: "30px",
            minHeight: "32px",
            textDecoration: "none"
        }),
        navbar: {
            marginBottom: "-20px",
            zIndex: "100",
            position: "relative",
            overflow: "hidden",
            "& header": {
                borderRadius: "0"
            }
        },
        navigation: {
            backgroundPosition: "center center",
            backgroundSize: "cover",
            marginTop: "0",
            minHeight: "740px"
        },
        formControl: (_obj = {}, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            margin: "10px 0 0 15px !important",
            color: bbhost/* grayColor */.X_
        }), (0,_define_property/* default */.Z)(_obj, "margin", "10px 0 0 0 !important"), (0,_define_property/* default */.Z)(_obj, "paddingTop", "0"), _obj),
        inputRootCustomClasses: {
            margin: "0!important"
        },
        searchIcon: {
            width: "20px",
            height: "20px",
            color: "inherit"
        }
    }, components_headerLinksStyle(theme)), {
        img: {
            width: "40px",
            height: "40px",
            borderRadius: "50%"
        },
        imageDropdownButton: (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, theme.breakpoints.down("md"), {
            top: "0",
            margin: "5px 15px"
        }), (0,_define_property/* default */.Z)(_obj1, "padding", "0px"), (0,_define_property/* default */.Z)(_obj1, "top", "4px"), (0,_define_property/* default */.Z)(_obj1, "borderRadius", "50%"), (0,_define_property/* default */.Z)(_obj1, "marginLeft", "5px"), _obj1)
    });
};
/* harmony default export */ var componentsSections_navbarsStyle = (navbarsStyle);


/***/ }),

/***/ 538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21086);



var landingPageStyle = {
    container: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        zIndex: "12",
        color: "#FFFFFF"
    }, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .container */ .nC),
    title: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, _styles_jss_bbhost_js__WEBPACK_IMPORTED_MODULE_0__/* .title */ .TN), {
        display: "inline-block",
        position: "relative",
        marginTop: "30px",
        minHeight: "32px",
        color: "#FFFFFF",
        textDecoration: "none"
    }),
    subtitle: {
        fontSize: "1.313rem",
        maxWidth: "500px",
        margin: "10px auto 0"
    },
    main: {
        background: "#FFFFFF",
        position: "relative",
        zIndex: "3"
    },
    mainRaised: {
        margin: "-60px 30px 0px",
        borderRadius: "6px",
        boxShadow: "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (landingPageStyle);


/***/ }),

/***/ 39832:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var tooltipsStyle = {
    tooltip: {
        padding: "10px 15px",
        minWidth: "130px",
        color: "#555555",
        lineHeight: "1.7em",
        background: "#FFFFFF",
        border: "none",
        borderRadius: "3px",
        boxShadow: "0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)",
        maxWidth: "200px",
        textAlign: "center",
        fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
        fontSize: "0.875em",
        fontStyle: "normal",
        fontWeight: "400",
        textShadow: "none",
        textTransform: "none",
        letterSpacing: "normal",
        wordBreak: "normal",
        wordSpacing: "normal",
        wordWrap: "normal",
        whiteSpace: "normal",
        lineBreak: "auto"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (tooltipsStyle);


/***/ })

}]);